<template>
  <section class="relative h-[600px] bg-gray-900">
    <img
      :src="heroImageUrl"
      fetchpriority="high"
      :alt="propertyName"
      class="w-full h-full object-cover opacity-80"
    />
    <div class="absolute inset-0 bg-gradient-to-r from-black/60 to-transparent flex items-center">
      <div class="container mx-auto px-4 text-white">
        <h1 class="text-5xl font-bold mb-4">{{ propertyName }}</h1>
        <p class="text-xl mb-6">{{ address }}</p>
        <div class="flex flex-wrap gap-6">
          <div class="flex items-center gap-2">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
            </svg>
            <span>{{ specifications.bedrooms }} {{ $t('property.bedrooms') }}</span>
          </div>
          <div class="flex items-center gap-2">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z" />
            </svg>
            <span>{{ specifications.bathrooms }} {{ specifications.bathrooms > 1 ? $t('property.bathrooms') : $t('property.bathroom') }}</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue';
import { resolvePropertyImageUrl } from '../../utils/propertyImageUrl.js';

const props = defineProps({
  propertyName: {
    type: String,
    required: true
  },
  address: {
    type: String,
    required: true
  },
  heroImage: {
    type: String,
    required: true
  },
  specifications: {
    type: Object,
    required: true
  }
});

const heroImageUrl = computed(() => resolvePropertyImageUrl(props.heroImage));
</script>
